import React from 'react';
import PropTypes from 'prop-types';
import ProfileImage from '../../../../../../common/ProfileImage';

const ResellerItem = ({ provider }) => {
	return (
		<div
			key={provider.id}
			className="experience-row-container"
			style={{ marginBottom: '16px' }}
			data-testid="participant-item"
		>
			<div style={{ display: 'flex' }}>
				<ProfileImage name={provider?.brand_name} photo={provider?.company_photo?.path} size={{ width: 32, height: 32,fontSize: 13, lineHeight: 16 }}/>
				<div>
					<h4
						style={{ marginLeft: '8px' }}
					>
						{provider.brand_name}
					</h4>
					<h4
						style={{ fontWeight: 'normal', marginLeft: '8px', marginTop: '3px' }}
					>
						{provider.first_name + ' ' + provider.last_name}
					</h4>
				</div>
			</div>
		</div>
	);
};

ResellerItem.propTypes = {
	provider: PropTypes.object.isRequired
};

export default ResellerItem;
